import gql from 'graphql-tag';

export const broadcastCreate = gql`
  mutation broadcastCreate($input: BroadcastCreateInput!) {
    broadcastCreate(input: $input) {
      broadcast {
        id
        type
        album_folder {
          id
        }
        album {
          id
        }
      }
    }
  }
`;

export const broadcastUpdate = gql`
  mutation broadcastUpdate($input: BroadcastUpdateInput!) {
    broadcastUpdate(input: $input) {
      success
      broadcast {
        id
        type
        album_folder {
          id
        }
        album {
          id
        }
        recipients {
          total
        }
      }
    }
  }
`;

export const broadcastsCreateAndSend = gql`
  mutation broadcastsCreateAndSend($input: BroadcastsCreateAndSendInput!) {
    broadcastsCreateAndSend(input: $input) {
      success
    }
  }
`;

export const broadcastUnsubscribe = gql`
  mutation broadcastUnsubscribe($input: BroadcastUnsubscribeInput!) {
    broadcastUnsubscribe(input: $input) {
      success
    }
  }
`;
